import React from 'react';
import {Navigate, Outlet} from "react-router-dom";

const ModelLayout = () => {
    return (
        <div className="relative w-full mx-auto max-w-7xl py-6 pl-8 pr-4">
            <Outlet/>
        </div>
    );
};

export const ModelIndexRedirect = () => <Navigate to="expense" replace/>;

export default ModelLayout;
